const { documentElement } = document

const inViewport = (el, offset = 0, container = documentElement) => {
  const elRect = el.getBoundingClientRect()
  let viewport = {}
  if (container === documentElement) {
    viewport = {
      top: -offset,
      left: -offset,
      right: documentElement.clientWidth + offset,
      bottom: documentElement.clientHeight + offset
    }
  } else {
    const containerRect = container.getBoundingClientRect()
    viewport = {
      top: containerRect.top - offset,
      left: containerRect.left - offset,
      right: containerRect.right + offset,
      bottom: containerRect.bottom + offset
    }
  }

  return (
    elRect.right >= viewport.left &&
    elRect.left <= viewport.right &&
    elRect.bottom >= viewport.top &&
    elRect.top <= viewport.bottom
  )
}

export default inViewport



// WEBPACK FOOTER //
// ./src/util/inViewport.js